module.exports = __webpack_public_path__ + "static/img/language.0afba2c8.svg";